// extracted by mini-css-extract-plugin
export default {"houseTypeImage":"Iqh2a4RmaM4ARPmb5TkL"};